import React from 'react';
import { Typography } from 'src/typography';
import styled from 'styled-components';

type DesktopEducationSectionProps = React.PropsWithChildren<{
  eyebrow: string;
  title: string;
  titleId: string;
}>;

export function DesktopEducationSection({
  children,
  eyebrow,
  title,
  titleId,
}: DesktopEducationSectionProps): JSX.Element {
  return (
    <Wrapper aria-labelledby={titleId}>
      <Eyebrow size='medium'>{eyebrow}</Eyebrow>
      <Title tag='h2' size='large' id={titleId}>
        {title}
      </Title>
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Eyebrow = styled(Typography.Body)`
  color: var(--dcm-pbb-desktop-education-eyebrow-color, ${({ theme }) => theme.colors.dutchiePayGreen});
  font-weight: 700;
  text-transform: var(--dcm-pbb-desktop-education-eyebrow-text-transform, uppercase);
`;

const Title = styled(Typography.Heading)`
  color: var(--dcm-pbb-desktop-education-title-color, ${({ theme }) => theme.colors.dutchiePayBlack});
`;

const ChildrenWrapper = styled.div`
  margin-top: 8px;
`;
